import { createContext, use } from 'react';

type StepperContextValue = {
  currentStep: number;
};

export const StepperContext = createContext<StepperContextValue | null>(null);

export const useStepperContext = () => {
  const context = use(StepperContext);

  if (!context) {
    throw new Error('Stepper compound components must be used inside Stepper.Root');
  }

  return context;
};
